'use client';

import { memo, useEffect } from 'react';

import { useIsClient } from 'usehooks-ts';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useMixPanel } from '@shared/common/providers/MixPanelProvider';

import type { MixpanelEventName } from '@api/mixPanel';

interface MixpanelBeaconProps {
  event: MixpanelEventName;
}

const MixpanelBeacon = memo(({ event }: MixpanelBeaconProps) => {
  const isClient = useIsClient();
  const { user } = useAuth();
  const { track } = useMixPanel();

  useEffect(() => {
    if (isClient) {
      track(event, { distinct_id: user?.id });
    }
  }, [event, track, isClient, user?.id]);

  return false;
});

export { MixpanelBeacon };
